// @flow

import { memo } from 'react';
import { trackViewItem } from '../../../../utils/googleAnalytics';

import type { DiamondType } from '@types/diamond';

export default memo(function ViewItemEvent({
  diamond,
}: {
  diamond: DiamondType,
}) {
  trackViewItem(diamond);

  return null;
},
  (prevProps, nextProps) => prevProps.diamond.id === nextProps.diamond.id,
);
